import router from './router'
import judicialRulingMessages from './localization'

export default {
  router,
  localization: judicialRulingMessages,
}
